function isAnimationControls(v) {
    return typeof v === "object" && typeof v.start === "function";
}

export { isAnimationControls };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/animation/utils/is-animation-controls.mjs
// module id = NxBk
// module chunks = 0